module.exports = __webpack_public_path__ + "static/media/banner_oquefalam_03.c74ec2a6.png";